import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  bidDeposit: null,
  winningBidData: null,
};

const depositSlice = createSlice({
  name: "bidDeposit",
  initialState,
  reducers: {
    setDepositData: (state, action) => {
      state.bidDeposit = action.payload;
      // console.log("auth data from redux", state.authData);
    },
    setWinningBidData: (state, action) => {
      state.winningBidData = action.payload;
      // console.log("auth data from redux", state.authData);
    },
  },
});
export const { setDepositData, setWinningBidData } = depositSlice.actions;
export default depositSlice.reducer;
